import React from 'react';
import ConstantMixin from 'app/mixins/ConstantMixin.js';
import * as IconFactory from 'app/components/common/IconFactory.jsx';

const AccountAvatar = (props) => {

    const getSwitchAccountUrl = (service) => {
        let switchUrl = '',
            constants = props.app.config.constants;

        switch (service) {
            case constants.POST_SVC_TUMBLR:
                switchUrl = 'https://tumblr.com/';
                break;

            case constants.POST_SVC_FACEBOOK:
            case constants.INPUT_TYPE_FACEBOOK_PAGE:
                switchUrl = 'https://facebook.com/';
                break;

            case constants.POST_SVC_PINTEREST:
                switchUrl = 'https://pinterest.com/';
                break;

            case constants.POST_SVC_STOCKTWITS:
                switchUrl = 'https://stocktwits.com/';
                break;

            case constants.POST_SVC_REDDIT:
                switchUrl = 'https://reddit.com/';
                break;

            case constants.POST_SVC_SNAPCHAT:
                switchUrl = 'https://snapchat.com/';
                break;
        }

        return switchUrl;

    };

    let accountAvatar = null,
        accountName = null,
        Icon = null,
        switchUrl = '',
        target = "_blank";

    if (props.userInfo && props.userInfo.avatarUrl !== '') {
        accountAvatar = (
            <img src={props.userInfo.avatarUrl}/>
        );
    } else {
        // a connection's service codes overlap the socials', and WordPress's is X's
        Icon = IconFactory[ConstantMixin.getIconIndexByCode(props.serviceID, (props.mode === 'GENERIC') ? 'generic' : undefined)];
        accountAvatar = (
            <Icon round={true}/>
        )
    }

    if (props.userInfo && props.userInfo.displayName !== '') {
        accountName = props.userInfo.displayName;
    } else {
        if (props.mode === "POST") {
            accountName = props.app.config.constants.POST_SVC_UINAMES[props.serviceID];
        } else if (props.mode === "INPUT") {
            accountName = props.app.config.constants.INPUT_TYPE_NAMES[props.serviceID];
        }
    }

    switchUrl = getSwitchAccountUrl(props.serviceID);

    if (!switchUrl) {
        switchUrl = props.initialUrl;
        target = "_self";
    }

    return (
        <div className="rc-profile-container">
            <div data-pw="account-avatar">
                {accountAvatar}
            </div>
            <div className="name">
                {accountName}<br/>
                <a href={switchUrl} target={target}>switch account</a>
            </div>
        </div>
    )
};

export default AccountAvatar;
